import type { FC } from 'react';

import { useApi } from '@backstage/frontend-plugin-api';
import { useEntity } from '@backstage/plugin-catalog-react';
import { isLeanixEntity } from '@ipen-portal/plugin-common';
import { Alert, Stack } from '@mui/material';
import { skipToken, useQuery } from '@tanstack/react-query';
import { tss } from 'tss-react/mui';

import { tdhApiRef } from '../apis';
import { DataRow } from './DataRow';
import { TdhDetailTile } from './TdhDetailTile';

const useStyles = tss.create(({ theme }) => ({
  alert: {
    marginTop: theme.spacing(1),
  },
  stack: {
    marginTop: theme.spacing(1),
  },
}));

export const LeanixInfoCard: FC = () => {
  const tdhApi = useApi(tdhApiRef);
  const { entity } = useEntity();
  const leanixId = isLeanixEntity(entity)
    ? entity.spec.leanix.aplElementId
    : undefined;
  const factsheetUrl = isLeanixEntity(entity)
    ? entity.spec.leanix.factsheetUrl
    : undefined;
  const { data, error, isLoading } = useQuery(
    tdhApi.getLeanix.queryOptions(
      leanixId ? { aplElementId: leanixId } : skipToken,
    ),
  );
  const { classes } = useStyles();

  const content = data
    ? (
        <Stack className={classes.stack} spacing={1}>
          <DataRow label="APL Element ID:" value={leanixId ?? '-'} />
          <DataRow label="Name:" value={data.aplName} />
          <DataRow label="Subtype:" value={data.subtype} />
          <DataRow label="Lifecycle:" value={data.lifecycle} />
        </Stack>
      )
    : (
        <Alert className={classes.alert} severity="info">
          No LeanIX ID available for this entity
        </Alert>
      );

  return (
    <TdhDetailTile
      error={error}
      factsheetUrl={factsheetUrl}
      icon="ipen:detail-pages-tile-solution-leanix"
      isLoading={isLoading}
      leanixId={leanixId}
      title="LeanIX"
    >
      {content}
    </TdhDetailTile>
  );
};
